import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=62cd82ae&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cd82ae')) {
      api.createRecord('62cd82ae', component.options)
    } else {
      api.reload('62cd82ae', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=62cd82ae&", function () {
      api.rerender('62cd82ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/ReceiptsReport/Page.vue"
export default component.exports